import React, { useEffect, useState, useCallback } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    Typography,
} from '@mui/material';
import UpdateIcon from '@mui/icons-material/Update';

const INITIAL_COUNTDOWN = 5;

const UpdateNotifier = () => {
    const [updateAvailable, setUpdateAvailable] = useState(false);
    const [countdown, setCountdown] = useState(INITIAL_COUNTDOWN);

    const applyUpdate = useCallback(() => {
        window.location.reload();
    }, []);

    useEffect(() => {
        if (!navigator.serviceWorker) return;

        const handleMessage = (event) => {
            if (event.data?.type === 'UPDATE_AVAILABLE') {
                setUpdateAvailable(true);
            }
        };

        navigator.serviceWorker.addEventListener('message', handleMessage);
        return () => navigator.serviceWorker.removeEventListener('message', handleMessage);
    }, []);

    useEffect(() => {
        if (!updateAvailable) return;

        const timer = setInterval(() => {
            setCountdown(prev => {
                if (prev <= 1) {
                    clearInterval(timer);
                    applyUpdate();
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(timer);
    }, [updateAvailable, applyUpdate]);

    return (
        <Dialog
            open={updateAvailable}
            disableEscapeKeyDown
            maxWidth="sm"
            fullWidth
            sx={{ '& .MuiDialog-paper': { borderRadius: 2, p: 1 } }}
        >
            <DialogTitle sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <UpdateIcon color="primary" sx={{ fontSize: 60, mb: 2 }} />
                Aggiornamento richiesto
            </DialogTitle>
            <DialogContent>
                <DialogContentText sx={{ textAlign: 'center', mb: 2 }}>
                    È disponibile una nuova versione dell'applicazione.
                    L'aggiornamento è necessario per continuare a utilizzare l'app.
                </DialogContentText>
                <Typography variant="h6" color="error" align="center" sx={{ mt: 2 }}>
                    Aggiornamento automatico tra {countdown} secondi
                </Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', mb: 2 }}>
                <Button onClick={applyUpdate} variant="contained" color="primary" size="large" sx={{ px: 4, py: 1 }}>
                    Aggiorna ora
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateNotifier;
